import { useRef } from 'react';
import { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from 'react-router-dom';
import classes from "./RegisterUser.module.css";
import UserService from "../../Services/UserService";
import { ReactComponent as Error } from '../../Assets/img/Error.svg';
import { ReactComponent as AddIcon } from '../../Assets/img/AddIcon.svg';
import { ReactComponent as ResetIcon } from '../../Assets/img/Reset-primary-icon.svg';
import { Modal, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import MessagePopup from "../PopupComponent/MessagePopup";

/**
 * Renders add role pop up to create role
 * @component
 * @param {Event} props.onClose() To close pop up
 * @param {Event} props.onShowMessage("message") To show message in pop up
 */
function AddRole(props) {

    //#region States

    const [error, setError] = useState("");
    const [messagePopup, setMessagePopup] = useState(false);

    //#endregion

    //#region Refs

    const roleInputRef = useRef();

    //#endregion

    //#region Add role

    /**
    * Calls user service to create role
    * @param   {Event} event  User action (on submitting form)
    */
    function createHandler(event) {
        event.preventDefault();

        const enteredRole = roleInputRef.current.value;

        var CreateRoleDTO = {
            Request:
            {
                Role: enteredRole
            }
        };

        UserService.createRole(CreateRoleDTO)
            .then((response) => {
                if (response.response == null) {
                    setError(response.errors[0].message);
                    setMessagePopup(true);
                }
                else {
                    props.onClose();
                    props.onShowMessage("Role created Sucessfully");
                }

            })
            .catch((err) => {
                setError(err.data);
                setMessagePopup(true);
            });
    }

    //#endregion

    return (
        <Modal centered={true} contentClassName="AddDeviceMain" show={true} onHide={props.onClose}>

            <ModalHeader className="AddDeviceHeader" style={{ border: "none" }} closeButton >
                <ModalTitle className="Header">
                    <strong>Add Role</strong>
                </ModalTitle>
            </ModalHeader>
            <Modal.Body style={{ padding: '0' }}>
                {messagePopup && (
                    <div className="alert alert-warning"><Error /><span className="message-popup-title">{error}</span></div>
                )}
                <form onSubmit={createHandler}>
                    <div style={{ padding: '3%' }}>
                        <div>
                            <label for="Username" className="label">Role Name</label>
                            <input
                                className="InputField"
                                placeholder="-Text-"
                                type="text"
                                ref={roleInputRef}
                                required
                            />
                        </div>
                    </div>
                    <ModalFooter className="AddDeviceFooter" style={{ border: "none" }}>
                        <div>
                            <button type="reset" className="secondary-button">
                                <span className="secondary-button-icon"><ResetIcon /></span>
                                <span className="secondary-button-text">Reset</span>
                            </button>
                            &nbsp;
                            <button type="submit" className="primary-button ">
                                <span className="primary-button-icon"><AddIcon /></span>
                                <span className="primary-button-text">Add Role</span>
                            </button>
                        </div>

                    </ModalFooter>
                </form>
            </Modal.Body>

        </Modal >
    );
}


export default AddRole;